import React from 'react';

const PageBanner = ({ banner, minHeight }) => {
  if (!banner) return null;
  const img = banner.image;
  // Responsive: 240px on mobile, scales to 420px on large screens
  const height = minHeight || 'clamp(240px, calc(30vw + 120px), 420px)';

  return (
    <div
      className="relative w-full overflow-hidden"
      style={{ minHeight: height }}
      data-testid="page-banner"
    >
      {/* Background image */}
      {img && (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${img})` }}
        />
      )}

      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#4A0F1E] via-[#4A0F1E]/60 to-black/30" />

      {/* Arch decorative pattern */}
      <div className="absolute inset-0 arch-pattern opacity-30" />

      {/* Content — pushed below navbar height */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center h-full" style={{ minHeight: height }}>
        <div className="pt-20 sm:pt-28 pb-8 sm:pb-12 px-4 sm:px-6 max-w-4xl mx-auto w-full">
          {banner.headline && (
            <h1 className="font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3 sm:mb-4 animate-fade-in break-words">
              {banner.headline}
            </h1>
          )}
          {banner.subtext && (
            <p className="text-white/80 text-sm sm:text-base md:text-lg max-w-2xl mx-auto mb-6 sm:mb-8 font-sans-custom animate-fade-in">
              {banner.subtext}
            </p>
          )}
          {banner.ctaText && banner.ctaLink && (
            <a
              href={banner.ctaLink}
              className="inline-flex items-center gap-2 bg-[#7A1125] hover:bg-[#8B1A2B] text-white font-semibold px-6 sm:px-8 py-3 rounded-full transition-colors duration-200 animate-fade-in"
              data-testid="banner-cta"
            >
              {banner.ctaText}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
